import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { createAssetType } from '@api/assetTypes';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IOnSuccess } from '@interfaces/common/handlers';
import { IResponseError } from '@interfaces/errors/apiErrors';
import { IAssetTypeDTO } from '@interfaces/platform/dto/manageAssetTypesDTO';

import { ESnackbarTypes } from '@enums/common';
import { EErrorCodes } from '@enums/errorCodes';

import { CREATE_ASSET_TYPE, MANAGE_ASSET_TYPES } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateCreateAssetType = ({ onSuccess }: IOnSuccess) => {
	const dispatch = useAppDispatch();

	const queryClient = useQueryClient();

	const {
		mutate: handleCreateAssetType,
		isLoading: isLoadingCreateAssetType,
	} = useMutation<IAssetTypeDTO>({
		mutationKey: [CREATE_ASSET_TYPE],
		mutationFn: createAssetType,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetTypeCreated,
				type: ESnackbarTypes.success,
			}));

			onSuccess();

			return [queryClient.invalidateQueries([MANAGE_ASSET_TYPES])];
		},
		onError: (err: IResponseError) => {
			if (!err.errors.find((item) => item.code === EErrorCodes.assetTypeNameMustBeUnique)) {
				handleErrorFromMessage(err);
			}
		},
	});

	return {
		handleCreateAssetType,
		isLoadingCreateAssetType,
	};
};
